let $container = $(".distributor-list");

export function init() {
	if ($container.length) {
		distributor_list();
	}
}

function distributor_list() {
	$.ajax({
		url: "/data/distributors/",
		success: create_select
	});
}

function create_select(data) {
	let $select = $("<select>");
	$select.addClass("distributor-list__select");

	// default state
	let $option = $("<option />");
	$option.val("");
	$option.text("Distributors");
	$select.append($option);

	// all the states
	data.forEach(element => {
		$option = $("<option />");
		$option.val(element.name);
		$option.text(element.title);
		$select.append($option);
	});
	attach_handlers($select);
	// attach final select to page
	$container.append($select);
}

function attach_handlers($select) {
	$select.on("change", function (e) {
		if (this.value) {
			get_distributor_data(this.value);
		} else {
			$(".distributor-list__list").remove();
		}
	});
}

function get_distributor_data(state) {
	$.ajax({
		url: `/data/distributors/${state}/`,
		success: list_distributors
	});
};

function list_distributors(data) {
	// delete any existing output elements
	$(".distributor-list__list").remove();
	// start from scratch with a new one
	let $output = $("<div />").addClass("distributor-list__list");
	data.forEach(element => {
		$output.append(distributor_entry(element));
	});
	$container.append($output);
}

function distributor_entry(data) {
	let $entry = $("<div>").addClass(`distributor-list__entry distributor-list__entry--${data.name}`);
	data.title ? $entry.append(`<h3 class="distributor-list__title">${data.title}</h3>`) : null;
	data.address ? $entry.append(`<div class="distributor-list__address">${data.address}</div>`) : null;
	data.city ? $entry.append(`<div class="distributor-list__city-state-zip">${data.city}, ${data.state} ${data.zip}</div>`) : null;
	data.phone ? $entry.append(`<div class="distributor-list__phone">${data.phone}</div>`) : null;
	data.fax ? $entry.append(`<div class="distributor-list__fax">${data.fax}</div>`) : null;
	data.url ? $entry.append(`<div class="distributor-list__url"><a href="${data.url}" target="_blank">${data.url}</a></div>`) : null;
	return $entry;
}
